import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import camera from "./Camera";
import renderer from "./Rendered";

// eslint-disable-next-line no-unused-vars


const controls = new OrbitControls(camera, renderer.domElement);
controls.enablePan = false;
controls.enableZoom = false;
//controls.target.set(0, 0, 0);
//si quiero que el orbit siga al cubo seria esta una solucion





